G.ProgressionFlowPanel = function(x, y, config) {
  Phaser.Group.call(this, game);
  this.position.setTo(x, y);

  this.config = config || {};
  this.cancelationTokens = {};

  this.preShowProgressDelay = 700;
  this.postShowProgressDelay = 700;

  this.currentPanel = null;
  this.panels = [
  new G.PFEventPanel({
      value: 10,
      valueTarget: 15,
      target: 20,
      progressBar: true,
    }),
    // this.add(new G.PFEventPanelMission({mission: G.globalGoalMgr.goals[0]})),
    // this.add(new G.PFEventPanelMission({goalObj: G.globalGoalMgr.goals[1], startValue: 100})),
    // this.add(new G.PFEventPanelMission({goalObj: G.globalGoalMgr.goals[2]})),
    // this.add(new G.PFEventPanelMission({goalObj: G.globalGoalMgr.goals[3]})),
    this.add(new G.PFEventPanelChest({chest: G.json.settings.mapChests[0], startValue: 0})),
    // this.add(new G.PFEventPanel()),
    // this.add(new G.PFEventPanel()),
    // this.add(new G.PFEventPanel()),
    // this.add(new G.PFEventPanel()),
  ];

  this.panels.forEach(function(panel) {
    panel.x = 400;
    panel.alpha = 0;
    this.add(panel);
    panel.onClick.add(function(){
      this.forceShowNext();
    }, this);
  }, this);

  this.showNextPanel();

  
};

G.ProgressionFlowPanel.prototype = Object.create(Phaser.Group.prototype);

G.ProgressionFlowPanel.prototype.showNextPanel = function() {

  var nextPanel = this.getNextPanel();

  if (nextPanel === null && this.currentPanel === null) return;

  if (this.currentPanel === nextPanel) {
    if (!this.config.cycle) {
      this.hidePanelAnim(this.currentPanel);
    }
    return;
  }

  if (this.currentPanel !== nextPanel) {
    if (this.currentPanel) this.hidePanelAnim(this.currentPanel);
    if (nextPanel) {

      var cancelationToken = game.rnd.uuid();
      this.cancelationTokens[cancelationToken] = false;
      this.currentCancelationToken = cancelationToken;
      this.currentPanel = nextPanel;
      
      this.showPanelAnim(this.currentPanel, function() {
        game.time.events.add(this.preShowProgressDelay,
          function() {
            if (this.cancelationTokens[cancelationToken]) return;
            this.currentPanel.showProgress();
          }, this);

        this.currentPanel.onShowProgressFinish.addOnce(function() {
          if (this.cancelationTokens[cancelationToken]) return;

          game.time.events.add(this.postShowProgressDelay,
            function() {
              if (this.cancelationTokens[cancelationToken]) return;
              this.showNextPanel();
            }, this);
        }, this);
      }, this);
    }
  } 

};

G.ProgressionFlowPanel.prototype.forceShowNext = function() {
  this.cancelationTokens[this.currentCancelationToken] = true;
  this.showNextPanel();
};

G.ProgressionFlowPanel.prototype.showPanelAnim = function(panel, callback, context) {
  panel.x = 400;
  panel.alpha = 0;
  var tween = game.add.tween(panel)
    .to({x: 0, alpha: 1}, 500, Phaser.Easing.Sinusoidal.InOut, true);

  if (callback) {
    tween.onComplete.add(callback, context);
  }
};

G.ProgressionFlowPanel.prototype.hidePanelAnim = function(panel, callback, context) {
  var tween = game.add.tween(panel)
    .to({x: -400, alpha: 0}, 500, Phaser.Easing.Sinusoidal.InOut, true);

  if (callback) {
    tween.onComplete.add(callback, context);
  }
};

G.ProgressionFlowPanel.prototype.getNextPanel = function() {
  if (this.panels.length == 0) {

    return null;

  } else {

    if (this.currentPanel === null) {

      return this.panels[0];

    } else {

      var newIndex = this.panels.indexOf(this.currentPanel)+1;

      if (newIndex >= this.panels.length) {
        if (this.config.cycle) {
          return this.panels[0];
        } else {
          return null;
        }
      } else {
        return this.panels[newIndex];
      }

    }
  }
};